import $ from 'jquery';
import Base from '../../../_config/base';

//Header class contains all the logic for identifying and binding header elements to dom manipulating functions.
class Header extends Base {
  constructor(el) {
    super(el);
    this.$el = $(el);

    // Get jQuery object
    this.header = this.$el;
    this.searchUrl = this.$el.data('searchurl');

    this.menuIcon = this.header.find('.menu-icon');
    this.menuIcon.on('click', this.toggleMenu.bind(this));

    this.searchIcon = this.header.find('.search-icon');
    this.searchIcon.on('click', this.toggleSearch.bind(this));
    
    this.closeMenuIcon = this.header.find('.close-menu-icon');
    this.closeMenuIcon.on('click', this.closeInnerMenu.bind(this));

    this.germanSelectorHeader = this.header.find('.de-picker');
    this.englishSelectorHeader = this.header.find('.en-picker');

    this.window = this.header[0].ownerDocument.defaultView;
    this.window.addEventListener('resize', this.checkWindowWidth.bind(this));
    this.window.addEventListener('load', this.checkWindowWidth.bind(this));

    this.searchFieldInput = this.header.find('.search-field-input');
    this.searchFieldInput.on('input', this.updateInputValue.bind(this));
    this.searchFieldInput.on('keypress', this.enterKeyPressed.bind(this));

    this.searchButton = this.header.find('.search-button');
    this.searchButton.on('click', this.triggerSearch.bind(this));
  }
  
  enterKeyPressed(e) {
    var code = e.keyCode || e.which;
    if(code == 13 && this.searchTerm) {
      window.location.href = this.searchUrl +  "?queryString=" + this.searchTerm;
    }
  }
  
  updateInputValue(e) {
    this.searchTerm = this.searchFieldInput.val();
  }
  
  triggerSearch(e) {
    if(this.searchTerm) {
      window.location.href = this.searchUrl +  "?queryString=" + this.searchTerm;
    }
  }

  closeInnerMenu(e) {
    this.header.removeClass('search-expanded');
    this.header.removeClass('expanded');
  }

  //Event listener to determine if dropdown nav was previously set and screen size increased
  checkWindowWidth(e) {
    if(this.window.innerWidth > 1200) {
      this.header.removeClass('expanded');
    }

    if(this.window.innerWidth > 1640) {
      console.log('Removing nav container');
      this.header.find('.navigation').removeClass('container');
      this.header.find('.nav-links.main-nav').addClass('container');

      this.header.find('a.logo').addClass('logo-absolute');
      this.header.find('.nav-right-links').addClass('nav-right-absolute');
    }

    if(this.window.innerWidth < 1640) {
      console.log('Adding nav container');
      this.header.find('.navigation').addClass('container');
      this.header.find('.nav-links.main-nav').removeClass('container');

      this.header.find('a.logo').removeClass('logo-absolute');
      this.header.find('.nav-right-links').removeClass('nav-right-absolute');
    }

    this.header.find('.navigation').removeClass('hide');
  }

  toggleSearch(e) {
    this.header.toggleClass('search-expanded');
    this.header.removeClass('expanded');
    this.searchFieldInput.focus();

  }

  toggleMenu(e) {
    this.header.toggleClass('expanded');
    this.header.removeClass('search-expanded'); 
  }

}

Header.className = 'Header';
export default Header;



// WEBPACK FOOTER //
// ./src/materials/organisms/header/header.js